// src/components/Header/Header.js
import React, { useContext } from 'react';
import './Header.css';
import AuthContext from '../../context/AuthContext';

const Header = () => {
  const { user, logout } = useContext(AuthContext);

  return (
    <div className="header mb-4">
      <div className="container d-flex justify-content-between align-items-center">
        <div>
          <h1>Digi Acai Internal Keyword Research Tool</h1>
          <p className="lead mb-0">
            Unlock valuable insights and intelligent analysis to help drive more organic traffic and optimize your content strategy.
          </p>
        </div>

        {/* Show only for logged-in user */}
        {user ? (
          <div className="user-info">
            <span className="username">👤 {user.username}</span>
            <button className="logout-btn" onClick={logout}>Logout</button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
